import { render, staticRenderFns } from "./ClusterForm.vue?vue&type=template&id=458a4ba8&"
import script from "./ClusterForm.vue?vue&type=script&lang=js&"
export * from "./ClusterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports